const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/plans-details', {
  title: 'Streaming Planos Detalhes',
  description: 'Esse componente oferece para o usuário todas as vantagens de um determinado serviço de streaming',
  icon: 'admin-site',
  category: 'design',
  attributes,

  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
